import { useEffect } from "react";

export const usePaginationFix = () => {
  useEffect(() => {
    const styleId = "global-pagination-fix";
    
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        .ant-pagination * { cursor: pointer !important; }
        .ant-pagination input, .ant-pagination .ant-select-selection-search-input {
          pointer-events: none !important;
          cursor: pointer !important;
          user-select: none !important;
        }
        .ant-pagination .ant-pagination-item,
        .ant-pagination .ant-pagination-prev,
        .ant-pagination .ant-pagination-next,
        .ant-pagination .ant-pagination-item-link,
        .ant-pagination .ant-pagination-options,
        .ant-pagination .ant-select-selector,
        .ant-pagination .ant-select-selection-search,
        .ant-pagination .ant-select-selection-item,
        .ant-pagination .ant-select-arrow {
          cursor: pointer !important;
        }
        .ant-pagination .ant-pagination-options-quick-jumper input {
          background-color: #f5f5f5 !important;
          color: #999 !important;
        }
        .ant-select-dropdown .ant-select-item { cursor: pointer !important; }
      `;
      document.head.appendChild(style);
    }
  }, []);
};